module.exports = "/images/exp-logo.png?fcd1f3effa9e8d12b532d1b1bc17e42b";